import { Box } from '@chakra-ui/react';
import { LoaderMark } from '@fluenceur/ui';
import React from 'react';

interface LoadingPageProps {
  /**
   * Background color of the loading page
   * @default "whiteSmoke"
   */
  bg?: string;
}

/**
 * A clean, minimal branded loading page component
 * Shows the Fluenceur mark drawing itself, centred on a full-height surface
 * Used to prevent content flashing during async operations
 */
export const LoadingPage: React.FC<LoadingPageProps> = ({ bg = 'whiteSmoke' }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      minHeight="100vh"
      bg={bg}
      width="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <LoaderMark size={88} />
    </Box>
  );
};
